<template>
    <article class="app-card">
        <div class="card-content">
            <slot name="content" />
        </div>

        <div class="card-actions">
            <slot name="actions" />
        </div>
    </article>
</template>

<style scoped lang="scss">
.app-card {
    background: $color-white;
    border-radius: 8px;
    box-shadow: 0 2px 8px $color-shadow;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    border: 1px solid $color-grey;
    border-left: 4px solid $color-primary;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
}

.card-content {
    flex: 1;
}

.card-actions {
    display: flex;
    gap: 0.75rem;
    margin-top: auto;
    justify-content: flex-end;
}
</style>